import {MenuItem} from '_metronic/layout/components/header/header-menus/MenuItem'
import {useLocation} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

const OnlineStdMenu = () => {
  const {t} = useTranslation()
  const location = useLocation()

  const menus = [
    {
      title: t('LABEL.MY_PROFILE'),
      to: '/os/my-profile',
      icon: 'fas fa-user-astronaut',
      color: '#8b5cf6',
    },
    {
      title: t('LABEL.MY_COURSES'),
      to: '/os/my-courses',
      icon: 'fas fa-graduation-cap',
      color: '#0d6efd',
    },
    // {
    //   title: t('LABEL.MY_RESOURCE'),
    //   to: '/os/my-resource',
    //   icon: 'fas fa-cloud-download-alt',
    //   color: '#64748b',
    // },
    // {
    //   title: t('LABEL.CHAT'),
    //   to: '/student/chat-room',
    //   icon: 'fas fa-comment-dots',
    //   color: '#0d6efd',
    // },
    {
      title: t('LABEL.MY_UMEF'),
      to: '/os/my-umef',
      icon: 'fas fa-landmark',
      color: '#8b5cf6',
      bgColor: '#f5f3ff',
      borderColor: '#8b5cf6',
    },
  ]

  const isMenuActive = (to?: string) => {
    if (!to) return false

    return location.pathname === to || location.pathname.startsWith(`${to}/`)
  }

  const renderMenu = (menu: any) => {
    const active = isMenuActive(menu.to)

    return (
      <div
        className={`compact-menu-item px-3 ${active ? 'active-menu-item' : ''}`}
        style={
          active
            ? {
                backgroundColor: '#f1f7ff',
                borderColor: '#d6e6ff',
              }
            : {
                backgroundColor: '#ffffff',
                borderColor: '#e5e7eb',
              }
        }
      >
        <div className='compact-icon'>
          <i
            className={menu.icon}
            style={{
              color: active ? '#0d6efd' : menu.color,
            }}
          />
        </div>

        <div className='menu-text'>
          <span
            className='menu-title'
            style={{
              color: active ? '#0d6efd' : '#334155',
            }}
          >
            {menu.title}
          </span>
        </div>

        <div className='menu-shine' />
      </div>
    )
  }

  return (
    <div className='modern-compact-menu'>
      <div className='menu-container'>
        {menus.map((menu, index) => (
          <MenuItem key={index} to={menu.to} title={renderMenu(menu)} />
        ))}
      </div>

      <style>{`
        .modern-compact-menu {
          width: 100%;
          font-family: 'Inter', 'Poppins', system-ui, sans-serif;
        }

        .menu-container {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
        }

        .compact-menu-item {
          position: relative;
          min-height: 58px;
          padding: 14px 22px;
          border: 1px solid #e5e7eb;
          border-radius: 14px;
          display: flex;
          align-items: center;
          gap: 12px;
          cursor: pointer;
          overflow: hidden;
          background: #ffffff;
          box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);
          transition: all 0.25s ease;
        }

        .compact-menu-item:hover {
          transform: translateY(-2px);
          background: #f8fbff !important;
          border-color: #cfe2ff !important;
          box-shadow: 0 8px 20px rgba(13, 110, 253, 0.12);
        }

        .active-menu-item {
          background: #f1f7ff !important;
          border-color: #d6e6ff !important;
          box-shadow: 0 8px 22px rgba(13, 110, 253, 0.14);
        }

        .active-menu-item::after {
          content: '';
          position: absolute;
          right: 0;
          bottom: 0;
          left: 0;
          height: 4px;
          background: #0d6efd;
          border-radius: 4px 4px 0 0;
        }

        .compact-icon {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: all 0.25s ease;
        }

        .compact-icon i {
          font-size: 20px !important;
        }

        .compact-menu-item:hover .compact-icon {
          transform: scale(1.08);
        }

        .menu-text {
          display: flex;
          align-items: center;
        }

        .menu-title {
          font-size: 14px;
          font-weight: 600;
          letter-spacing: -0.2px;
          white-space: nowrap;
        }

        .menu-shine {
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          pointer-events: none;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.5),
            transparent
          );
          transition: left 0.6s ease;
        }

        .compact-menu-item:hover .menu-shine {
          left: 100%;
        }

        @media (max-width: 900px) {
          .menu-container {
            gap: 5px;
          }

          .compact-menu-item {
            min-height: 30px;
            padding: 5px;
            gap: 2px;
          }

          .compact-icon i {
            font-size: 18px !important;
          }

          .menu-title {
            font-size: 13px;
          }
        }

        @media (max-width: 680px) {
          .menu-container {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
          }

          .compact-menu-item {
            justify-content: center;
          }
        }

        @media (max-width: 480px) {
          .compact-menu-item {
            min-height: 48px;
            padding: 9px 12px;
            gap: 8px;
          }

          .compact-icon i {
            font-size: 16px !important;
          }

          .menu-title {
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  )
}

export default OnlineStdMenu
